import template from './users-management.html'

class UsersManagePageVM
{
	constructor (page)
	{
		this.page = page;

		this.tabs = ko.observableArray([
			{
				title: 'Users',
				route: '[/]ui/admin/users',
				icon: 'fa-regular fa-users'
			},
			{
				title: 'Roles and Groups',
				route: '[/]ui/admin/access-roles',
				icon: 'fa-regular fa-lock-a'
			},
			/*
			{
				title: 'Privileges',
				route: '[/]ui/admin/acl-privileges',
				icon: 'fa-regular fa-lock-hashtag'
			},*/
			{
				title: 'Networks',
				route: '[/]ui/networks',
				icon: 'fa-regular fa-code-fork'
			},
			{
				title: 'Sessions',
				route: '[/]ui/sessions',
				icon: 'fa-regular fa-info-circle'
			},
			{
				title: 'Profile',
				route: '[/]grape-ui/my-profile',
				icon: 'fa-regular fa-info-circle'
			}

		]);
		this.current_route = ko.observable('[/]ui/users');
	}

	load_tab (route)
	{
		const element = document.querySelector('.users_page_content');
		this.current_route(route);
		const page = Grape.pages.find_page_by_id(route);
		if (!page)
			throw new Error(`Page with id "${route}" not found`);

		const bindings = {};
		if (route == '[/]grape-ui/my-profile')
			bindings.show_user_picker = true;

		Grape.pages.load_page(page, element, bindings, {}, () => {});
	}
}

class UsersManagePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new UsersManagePageVM(this);
		this.open_profile_handler = () => {
			this.viewModel.load_tab('[/]grape-ui/my-profile');
		};
	}

	init ()
	{
		document.title = 'Users Management';
		Grape.BreadCrumb.push({ default_route: { 'Home': '/ui/landing', 'Setup': '/ui/crm/setup-page',  'Users': '/ui/users/manage' } });
		window.addEventListener('ui.users-manage.open-profile', this.open_profile_handler);
		this.viewModel.load_tab('[/]ui/admin/users');
	}

	teardown ()
	{
		window.removeEventListener('ui.users-manage.open-profile', this.open_profile_handler);
	}
}

export default {
	route: '[/]ui/users/manage',
	page_class: UsersManagePage,
	template: template,
	title: 'Users'
}
